import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SharedModule } from 'src/app/shared/shared.module';
import { SqpComponentsModule } from 'src/app/shared/components/sqp-components/sqp-components.module';
import { SqpUiModule } from '@squarepoint/sqp-ui';
import { DocumentosModule } from '../Envios/documentos/documentos.module';
import { EnviosModule } from '../Envios/Envios.module';
import { EmpleadosModule } from 'src/app/pages/empleados/empleados.module';
import { EnvioSimpleDocumentosPageComponent } from './components/envio-simple-documentos-page/envio-simple-documentos-page.component';
import { EnvioSimpleZonaCargaComponent } from './components/envio-simple-zona-carga/envio-simple-zona-carga.component';
import { EnvioSimpleStepperComponent } from './components/envio-simple-stepper/envio-simple-stepper.component';
import { EnvioSimpleFicherosSubidosComponent } from './components/envio-simple-ficheros-subidos/envio-simple-ficheros-subidos.component';
import { EnvioSimpleFirmantesPageComponent } from './components/envio-simple-firmantes-page/envio-simple-firmantes-page.component';
import { EnvioSimpleEnvioPageComponent } from './components/envio-simple-envio-page/envio-simple-envio-page.component';
import { EnvioSimpleFirmanteCardComponent } from './components/envio-simple-firmante-card/envio-simple-firmante-card.component';
import { EnvioSimpleFirmantesListComponent } from './components/envio-simple-firmantes-list/envio-simple-firmantes-list.component';
import { EnvioSimpleConfirmacionPageComponent } from './components/envio-simple-confirmacion-page/envio-simple-confirmacion-page.component';
import { EnvioSimpleConfirmacionFirmantesGridComponent } from './components/envio-simple-confirmacion-firmantes-grid/envio-simple-confirmacion-firmantes-grid.component';


@NgModule({
  declarations: [
    EnvioSimpleDocumentosPageComponent,
    EnvioSimpleStepperComponent,
    EnvioSimpleZonaCargaComponent,
    EnvioSimpleFicherosSubidosComponent,
    EnvioSimpleFirmantesPageComponent,
    EnvioSimpleEnvioPageComponent,
    EnvioSimpleFirmanteCardComponent,
    EnvioSimpleFirmantesListComponent,
    EnvioSimpleConfirmacionPageComponent,
    EnvioSimpleConfirmacionFirmantesGridComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SqpComponentsModule,
    SqpUiModule,
    MatDialogModule,
    MatSnackBarModule,
    DragDropModule,
    DocumentosModule,
    EnviosModule,
    EmpleadosModule
  ]
})
export class EnvioSimpleModule { }
